<template>
  <div
    id="app"
    :class="theme"
  >
    <router-view />
    <be-loading
      :is-global="true"
      ref="gLoadingBar"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import ResponseErrorModal from './components/Modal/ResponseErrorModal'

export default {
  name: 'App',
  computed: {
    theme () {
      return '-theme-' + 'dark'
    },
    ...mapGetters([
      'shouldShow'
    ])
  },
  created () {
    this.$store.dispatch('alarmSocketConnect')
  },
  mounted () {
  },
  watch: {
  },
  methods: {
    // showResponseError (err) {
    //   this.$buefy.modal.open({
    //     component: ResponseErrorModal,
    //     hasModalCard: true,
    //     props: {
    //       visible: true,
    //       title: err.exceptionType || 'Error',
    //       message: err.exceptionMessage,
    //       className: err.className,
    //       methodName: err.methodName,
    //       lineNumber: err.lineNumber
    //     }
    //   })
    // },
    // enableInterceptor () {
    //   this.axios.interceptors.request.use((req) => {
    //     return new Promise((resolve) => {
    //       this.$store.dispatch(ADD_LOADER)
    //       resolve(req)
    //     })
    //   }, (error) => {
    //     return Promise.reject(error)
    //   })
    //   this.axios.interceptors.response.use((response) => {
    //     return new Promise((resolve) => {
    //       this.$store.dispatch(REMOVE_LOADER)
    //       this.$store.commit(REQUEST_DATE)
    //       resolve(response)
    //     })
    //   }, async error => {
    //     this.$store.dispatch(REMOVE_LOADER)
    //     if (error.response !== null && error.response.status === 401) {
    //       console.log('@@ error Message : ', error.response.data.errorName)
    //     } else {
    //       if (error.response.status >= 401) {
    //         this.showResponseError(error.response.data)
    //       }
    //       return Promise.reject(error)
    //     }
    //   })
    // }
  },
  data () {
    return {
    }
  }
}
</script>
<style src="./style/style.scss" lang="scss" />
